module.exports = __webpack_public_path__ + "img/upi-make-payment.84398972.png";